const messages = {
  pageTitle: 'Perfil de Usuario',
  sections: {
    personalInfo: 'Informacion Personal',
  },
  fields: {
    name: 'Nombre',
    surname: 'Apellidos',
    email: 'Email',
  },
  validation: {
    emailRequired: 'El email es obligatorio',
  },
  actions: {
    save: 'Guardar',
    resetPassword: 'Restablecer Contrasena',
  },
  password: {
    title: 'Restablecer Contrasena',
    show: 'Mostrar contrasena',
    hide: 'Ocultar contrasena',
    fields: {
      current: 'Contrasena Actual',
      new: 'Contrasena Nueva',
      confirm: 'Confirmar Contrasena Nueva',
    },
    errors: {
      currentRequired: 'La contrasena actual es obligatoria',
      newRequired: 'Este campo es obligatorio',
      confirmRequired: 'Este campo es obligatorio',
      minLength: 'La contrasena debe tener al menos %{min} caracteres',
      pattern:
        'La contrasena debe tener al menos una mayuscula, una minuscula, un digito y un caracter especial.',
      mismatch: 'Las contrasenas no coinciden',
    },
  },
  notifications: {
    profileUpdated: 'Datos del usuario actualizados correctamente',
    passwordUpdated: 'Contrasena actualizada correctamente',
    loadFailed: 'Error al cargar el perfil',
    saveFailed: 'Error al guardar el perfil',
    passwordFailed: 'Error al actualizar la contrasena',
  },
};

export default messages;
